import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=782db9fe&scoped=true&"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=782db9fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782db9fe",
  null
  
)

export default component.exports